import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import config from '../config';
import commonReducers from './reducers';
import commonSagas from './sagas';

const configureSaga = sagas => function* configureSagaGenerator() {
  yield all(sagas.map(saga => fork(saga)));
};

const Store = (() => {
  let instance;

  const createInstance = ({ initReducers, initSagas, initMiddlewares }) => {
    // set defaults
    const platformReducers = initReducers || {};
    const platformSagas = initSagas || [];
    const platformMiddlewares = initMiddlewares || [];

    let middleware = [];

    // Create and add Redux Saga middleware
    const sagaMiddleware = createSagaMiddleware();
    middleware.push(sagaMiddleware);

    // Platform spesific middlewares
    if (platformMiddlewares) {
      middleware = middleware.concat(platformMiddlewares);
    }

    // Dev tools like redux for chrome
    // Only run devtools in development mode.
    let devTools = f => f;
    if (config.STAGE === 'development') {
      // eslint-disable-next-line no-undef
      if (window && window.__REDUX_DEVTOOLS_EXTENSION__) {
        // eslint-disable-next-line no-undef
        devTools = window.__REDUX_DEVTOOLS_EXTENSION__();
        console.log('React and Redux DevTools is ON');
      }
    }

    const enhancer = compose(applyMiddleware(...middleware), devTools);

    if (!Object.keys(platformReducers).length) {
      platformReducers._ = (s = {}) => s;
    }

    const store = createStore(
      combineReducers({ ...commonReducers, ...platformReducers }),
      enhancer,
    );

    // Optionaly persist the store
    // persistStore(store, persistConfig);

    // This block should be only after the store creation! Order is important!
    sagaMiddleware.run(configureSaga([...commonSagas, ...platformSagas]));

    return store;
  };

  return {
    getInstance: (defaults = {}) => {
      if (!instance) {
        instance = createInstance(defaults);
      }
      return instance;
    },
  };
})();

export default Store;
